import { useAuth as useChainlitAuth } from '@chainlit/react-client';

import type { DatamindsUser } from '@/types/auth';

/**
 * Extended useAuth hook with properly typed Dataminds user.
 * This wraps the Chainlit useAuth hook and provides proper typing
 * for the user metadata including organization_roles.
 */
export function useAuth() {
    const auth = useChainlitAuth();

    return {
        ...auth,
        /**
         * The current user with properly typed metadata.
         * Will be null if not authenticated.
         */
        user: auth.user as DatamindsUser | null,
    };
}

export type { DatamindsUser, DatamindsUserMetadata } from '@/types/auth';
